import {connect} from 'react-redux';
import Header from './Header';

const mapStateToProps = ({
                           user: {firstName}
                         }) => ({
  firstName
});

export default connect(
  mapStateToProps,
  null
)(Header);
